module.exports = __webpack_public_path__ + "img/glazing-double.53c15c5.svg";